import React from 'react';

import { NamedLink } from '../../../components';

import { SEARCH_BREADCRUMB_ROOT_LABEL, searchRoutePropsForIds } from './searchRouteProps';
import css from './CategorySeo.module.css';

/**
 * Breadcrumb trail + H1 for search/category pages.
 * The trail starts with the brand root "Avento" linking to /s (eBay-style).
 * The visible labels are the source of truth for the BreadcrumbList schema,
 * which mirrors them exactly (see buildSearchBreadcrumbSchema).
 * Also reused without a title on listing pages (desktop breadcrumb), where
 * the trail is the listing's category path and linkedLeaf makes every level
 * clickable, including the deepest category.
 */
const CategorySeoHeader = props => {
  const { trail = [], title, linkedLeaf = false } = props;
  const isRoot = trail.length === 0;

  return (
    <div className={css.seoHeader}>
      <nav className={css.breadcrumbs} aria-label="Breadcrumb">
        <ol className={css.breadcrumbList}>
          {/* Separators are suffixes of the preceding item so that on line
              breaks the ">" stays with the word before it and wrapped lines
              start flush left with the first line. */}
          <li className={css.breadcrumbItem}>
            {isRoot ? (
              <span className={css.breadcrumbLeaf} aria-current="page">
                {SEARCH_BREADCRUMB_ROOT_LABEL}
              </span>
            ) : (
              <>
                <NamedLink name="SearchPage" className={css.breadcrumbLink}>
                  {SEARCH_BREADCRUMB_ROOT_LABEL}
                </NamedLink>
                <span className={css.breadcrumbSeparator} aria-hidden="true">
                  &gt;
                </span>
              </>
            )}
          </li>
          {trail.map((crumb, index) => {
            const isLeaf = index === trail.length - 1;
            return (
              <li key={crumb.id} className={css.breadcrumbItem}>
                {isLeaf && !linkedLeaf ? (
                  <span className={css.breadcrumbLeaf} aria-current="page">
                    {crumb.label}
                  </span>
                ) : (
                  <>
                    <NamedLink
                      {...searchRoutePropsForIds(trail.slice(0, index + 1).map(c => c.id))}
                      className={isLeaf ? css.breadcrumbLeafLink : css.breadcrumbLink}
                    >
                      {crumb.label}
                    </NamedLink>
                    {!isLeaf ? (
                      <span className={css.breadcrumbSeparator} aria-hidden="true">
                        &gt;
                      </span>
                    ) : null}
                  </>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      {title ? <h1 className={css.pageTitle}>{title}</h1> : null}
    </div>
  );
};

export default CategorySeoHeader;
